import React, { useRef, useEffect, FC } from 'react';

const APP_FORM_URL = 'https://form-builder.io';

export interface IFormbuilderForm {
  id: string;
  initialValues?: { [key: string]: any };
  disableFields?: string[];
  hideSubmit?: boolean;
  onSubmit?: (values: { [key: string]: any }) => void;
}

const FormBuilderForm: FC<IFormbuilderForm> = (props) => {
  const formRef = useRef<HTMLIFrameElement>(null);
  useEffect(() => {
    const submitHandler = (event: any) => {
      if (event.data && typeof event.data === 'string' && props.onSubmit) {
        const data = JSON.parse(event.data);
        props.onSubmit(data);
      }
    };
    window.addEventListener('message', submitHandler);
    return () => window.removeEventListener('message', submitHandler);
  }, []);
  return (
    <iframe
      style={{ width: '100%', height: '100%' }}
      ref={formRef}
      data-testid="formbuilder-form"
      onLoad={() => {
        if (formRef && formRef.current) {
          formRef.current.contentWindow!.postMessage(
            JSON.stringify({
              values: props.initialValues,
              disableFields: props.disableFields,
              handleSubmit: !!props.onSubmit,
              hideSubmit: props.hideSubmit,
            }),
            '*'
          );
        } else {
          console.error('Unable to Post Config to FormBuilder Form.');
        }
      }}
      src={`${APP_FORM_URL}/f/${props.id}`}
    />
  );
};

export default FormBuilderForm;
